export const priceFormatter = (price: number): string => {
  return `${(price / 100).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
  })}`;
};
